import { render, staticRenderFns } from "./FinanceConfig.vue?vue&type=template&id=38878ce6&scoped=true"
import script from "./FinanceConfig.vue?vue&type=script&lang=js"
export * from "./FinanceConfig.vue?vue&type=script&lang=js"
import style0 from "./FinanceConfig.vue?vue&type=style&index=0&id=38878ce6&prod&scoped=true&lang=css"
import style1 from "./FinanceConfig.vue?vue&type=style&index=1&id=38878ce6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38878ce6",
  null
  
)

export default component.exports